import { useState } from "react";
import {
  Button,
  ButtonSize,
  ButtonVariant,
  IconButton,
  IconButtonSize,
  IconButtonVariant,
  Input,
  InputSize,
  Show
} from "shared/components";
import { FilterLines } from "untitledui-js-base";
import {
  Download02Icon,
  PlusSignIcon
} from "@hugeicons-pro/core-stroke-rounded";
import { CreateLeadModal } from "shared/app/LeadsTableView/components/CreateLeadModal";
import { AssigneeFilterPopover } from "shared/components/Assignee";
import { useLocation } from "react-router-dom";

export const LeadsHeader = ({
  refetchLeads,
  search,
  setSearch,
  isCreateLeadModalOpen,
  hasHeaderTitle,
  setIsCreateLeadModalOpen,
  selectedAssigneeIds,
  setSelectedAssigneeIds,
  onPageChange,
  setShowFilters
}: {
  refetchLeads: () => void;
  search: string;
  hasHeaderTitle?: boolean;
  setSearch: (search: string) => void;
  isCreateLeadModalOpen: boolean;
  setIsCreateLeadModalOpen: (isOpen: boolean) => void;
  selectedAssigneeIds: number[] | null;
  setSelectedAssigneeIds: (userIds: number[] | null) => void;
  onPageChange: (page: string) => void;
  setShowFilters: (show: boolean) => void;
}) => {
  const [assigneeFilterOpen, setAssigneeFilterOpen] = useState(false);
  const location = useLocation();

  const shouldShowSideButtons = !location.pathname.includes("/contacts");
  return (
    <header>
      <Show if={hasHeaderTitle}>
        <h1 className="text-2xl font-bold text-content-1000 mb-6">Leads</h1>
      </Show>
      <div className="mb-4">
        <div className="flex flex-wrap gap-3 items-center">
          <div className="max-w-[272px] w-full">
            <Input
              id="leads-search"
              size={InputSize.SM}
              hideOptional
              placeholder="Search leads"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="text-sm font-medium"
              legacyErrorMargins={false}
            />
          </div>
          <IconButton
            aria-label="Filters"
            variant={IconButtonVariant.BASE}
            size={IconButtonSize.SM}
            onClick={() => setShowFilters(true)}
            Icon={FilterLines}
          />
          <div className="max-w-[272px] w-full">
            <AssigneeFilterPopover
              open={assigneeFilterOpen}
              onOpenChange={setAssigneeFilterOpen}
              selectedUserIds={selectedAssigneeIds}
              onSelectedUserIdsChange={setSelectedAssigneeIds}
              onPageChange={onPageChange}
            />
          </div>
          <Show if={shouldShowSideButtons}>
            <div className="ml-auto flex gap-2">
              <Button
                variant={ButtonVariant.BASE}
                size={ButtonSize.SM}
                disabled
                onClick={() => alert("WIP")}
                HugeIcon={Download02Icon}
              >
                Download CSV
              </Button>
              <Button
                variant={ButtonVariant.PRIMARY}
                size={ButtonSize.SM}
                HugeIcon={PlusSignIcon}
                onClick={() => setIsCreateLeadModalOpen(true)}
              >
                Create lead
              </Button>
            </div>
          </Show>
        </div>
      </div>

      <CreateLeadModal
        open={isCreateLeadModalOpen}
        refetchLeads={refetchLeads}
        onClose={() => setIsCreateLeadModalOpen(false)}
      />
    </header>
  );
};
